import { TranslateText } from '@/helpers/utils/siteUtils';
import { DEFAULT_SITE_LANG } from '../../../../../constants/constant';
import { PageTexts } from '../i18n';

const Texts = TranslateText(PageTexts, DEFAULT_SITE_LANG);

export const ADJUST_ORDER_CONSTANTS = {
  ADJUSTMENTS: [
    {
      key: 'dollarOff',
      value: Texts.DOLLAR_OFF,
    },
    {
      key: 'percentageOff',
      value: Texts.PERCENT_OFF,
    },
    {
      key: 'removeStandard',
      value: Texts.REMOVE_STANDARD_SHIPPING_CHARGE,
    },
    {
      key: 'removeExpedited',
      value: Texts.REMOVE_EXPEDITED_SHIPPING_CHARGE,
    },
    {
      key: 'removeAll',
      value: Texts.REMOVE_ALL_SHIPPING_CHARGES,
    },
  ],
  REASONS: [
    {
      key: 'reason-1',
      value: Texts.CUSTOMER_SERVICE_ISSUE,
    },
    {
      key: 'reason-2',
      value: Texts.CUST_PD_POSTAGE_REFUND,
    },
    {
      key: 'reason-3',
      value: Texts.SMART_LABEL_ISSUE,
    },
    {
      key: 'reason-4',
      value: Texts.PROBLEMS_WITH_PZ,
    },
    {
      key: 'reason-5',
      value: Texts.SHIPPING_ERROR,
    },
  ],
};

export const OrderNotesOptions = [
  Texts.CUSTOM_NOTE,
  Texts.STATUS_TRACKING_PROVIDED,
  Texts.STATUS_NOT_SHIPPED_REASON,
  Texts.STATUS_NOT_SHIPPED_CREDIT,
  Texts.STATUS_DP_REQUESTED,
  Texts.ADDRESS_CHANGE_SUCCESS,
  Texts.ADDRESS_CHANGE_UNABLE,
  Texts.RETURN_STATUS_IN_TRANSIT,
  Texts.RETURN_STATUS_RECEIVED,
  Texts.RETURN_STATUS_TRANSFER,
  Texts.RETURN_SMART_LABEL,
  Texts.RETURN_CHARGE_LABEL,
  Texts.EXCHANGE_ORDER,
  Texts.EXCHANGE_ORIGINAL_ORDER,
  Texts.DOWN_PAYMENT_MADE,
  Texts.PAYMENT_ON_ACCOUNT,
  Texts.DOWN_PAYMENT_INQUIRY,
  Texts.LOST_IN_TRANSIT_TRANSFER,
  Texts.SENT_TRACER,
  Texts.FRAUD_CLAIM,
  Texts.DAMAGED_ZB_FB,
  Texts.DAMAGED_WAIVE_FEE,
];
